<template>
	<div id="loader-wrapper" v-if="isFetching">
		<div id="loader"></div>
		<div class="loader-section section-left"></div>
		<div class="loader-section section-right"></div>
	</div>

	<div class="shipyard-detail" v-else-if="!isFetching && shipyard">
		<b-modal id="success-modal" centered title="BootstrapVue">
				<img src='/images/icons/success_icon.gif' style="width:50%; display:block; margin:auto;" alt="no-image">
			<p class="my-4" style="padding-left:20px; text-align:center; color:#152734; line-height:25px;">Your request was sent successfully <br> shipyard will contact your email.</p>
		</b-modal>

		<b-container>
			<b-row>
				<div class="col-lg-12">
					<div class="shipyard-breadcrumb mbtm-20">
						<a>Shipyard Explore</a>
						<span class="divider"> / </span>
						<a>{{shipyard.city.name}}</a>
						<span class="divider"> / </span>
						<span class="current">{{shipyard.name}}</span>
					</div>
				</div>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<b-col style="text-align:center;" lg="6" md="12" v-if="shipyard.images.length == 0">
					<img src='/images/shipyard-occupancy.png' style="width:90%;" alt="no-image">
				</b-col>
				<b-col lg="6" md="12" v-else>
					<div>
						<b-carousel
							id="carousel1"
							class="shipyard-image-detail"
							style="text-shadow: 1px 1px 2px #333; border-radius:5px; overflow:hidden;"
							controls
							indicators
							background="#ababab"
							:interval="4000"
							img-width="1024"
							img-height="500"
							v-model="slide"
							@sliding-start="onSlideStart"
							@sliding-end="onSlideEnd"
						>
							<b-carousel-slide :img-src="image.photo" v-for="(image, i) in shipyard.images" :key="i"/>
						</b-carousel>
					</div>
				</b-col>

				<b-col lg="6" md="12" class="pos-relative">

					<div class="company-contact-badge">
						<b-row>
							<b-col lg="5" md="12" class="logo">
								<img :src="shipyard.logo" alt="company_name" />
								<div class="share-box desktop-only">
									<span>Share this shipyard :</span>
									<ul>
										<li><a @click="PopupCenter('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), 'Share this shipyard on Facebook')" class="fb"></a></li>
										<li><a @click="PopupCenter('https://twitter.com/intent/tweet?url=' + url,'Share to Twitter',undefined,253)" href="#" class="twitter"></a></li>
										<li><a :href="'mailto:' + shipyard.email + '?subject=Check ' + shipyard.name + ' on docking.id'" class="email"></a></li>
									</ul>
								</div>
							</b-col>
							<b-col lg="7" md="12">
								<h2 class="company-name">{{shipyard.company.name}}</h2>
								<div class="company-location">
									<span class="city">City : {{shipyard.city.name}}</span>
									<span class="longlat">long : {{shipyard.long}} - lat : {{shipyard.lat}}</span>

								</div>
								<b-row class="contact-list">
									<b-col class="label" sm="6" md="4" lg="3">
										Phone :
									</b-col>
									<b-col class="content" sm="6" cols="8" lg="9">
										<p>{{shipyard.officePhone}}</p>
									</b-col>
								</b-row>

								<b-row class="contact-list">
									<b-col class="label" sm="2" cols="4" lg="3" >
										Email :
									</b-col>
									<b-col class="content" sm="10" cols="8" lg="9" >
										<a class="email_shipyard" target="_blank" :href="'mailto:'+shipyard.email" >{{shipyard.email}}</a>
									</b-col>
								</b-row>

								<b-row class="contact-list" v-if="shipyard.company.website != null">
									<b-col class="label" sm="2" cols="4" lg="3" >
										Website :
									</b-col>
									<b-col class="content" sm="10" cols="8" lg="9" >
										<a class="email_shipyard" target="_blank" :href="'http://'+shipyard.company.website" >{{shipyard.company.website}}</a>
									</b-col>
								</b-row>

								<div class="share-box mobile-only">
									<span>Share this shipyard :</span>
									<ul>
										<li><a @click="PopupCenter('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), 'Share this shipyard on Facebook')" class="fb"></a></li>
										<li><a @click="PopupCenter('https://twitter.com/intent/tweet?url=' + url,'Share to Twitter',undefined,253)" href="#" class="twitter"></a></li>
										<li><a :href="'mailto:' + shipyard.email + '?subject=Check ' + shipyard.name + ' on docking.id'" class="email"></a></li>
									</ul>
								</div>

							</b-col>
						</b-row>
					</div>

					<a name="button" class="btn-primary kirim-pesan" v-b-modal.modalMessageShipyard>Contact {{shipyard.name}}</a>

				</b-col>

			</b-row>
		</b-container>

		<b-container>

			<b-row>
				<b-col>
					<div class="company-desc">

						<div class="service-icon desktop-only">
							<div class="repair">
								<h4>Repairs</h4>
							</div>
							<div class="build">
								<h4>New Build</h4>
							</div>
							<div class="brochure" v-if="shipyard.brochure">
								<a class="btn-primary" :href="shipyard.brochure" download>Download</a>
							</div>
						</div>
						<h1 class="company-title f-white">
							{{shipyard.company.name}}
						</h1>

						<div class="service-icon desktop-mobile">
							<div class="repair" v-show="repairService.length">
								<h4>Repairs</h4>
							</div>
							<div class="build" v-show="buildService.length">
								<h4>New Build</h4>
							</div>
							<div class="brochure" v-if="shipyard.brochure">
								<a class="btn-primary" :href="shipyard.brochure" download>Download</a>
							</div>
						</div>

						<p class="f-white">
							{{shipyard.company.description}}
						</p>
						<b-row>
							<div class="col-lg-6 col-md-12" v-if="shipyard.shipyardCertificate.length">
								<div class="map-location">
									<h3>Location on map</h3>
									<div class="map mtop-20">
										<l-map :zoom="5" :center="getLatLang(shipyard)">
											<l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
											<l-marker v-if="shipyard.lat && shipyard.long" :lat-lng="getLatLang(shipyard)"></l-marker>
										</l-map>
									</div>
								</div>
							</div>

							<div class="col-lg-12 col-md-12" v-if="shipyard.shipyardCertificate.length == 0">
								<div class="map-location">
									<h3>Location on map</h3>
									<div class="map mtop-20">
										<l-map :zoom="5" :center="getLatLang(shipyard)">
											<l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
											<l-marker v-if="shipyard.lat && shipyard.long" :lat-lng="getLatLang(shipyard)"></l-marker>
										</l-map>
									</div>
								</div>
							</div>

							<b-col lg="6" md="12" v-if="shipyard.shipyardCertificate.length">
								<div class="certification">
									<h3>Certification</h3>

									<ul class="mtop-20" v-if="shipyard.shipyardCertificate.length">
										<li class="list" v-for="(certificate, i) in shipyard.shipyardCertificate" :key="i">
											<img :src="certificate.certificate.logo" alt="" />
										</li>
									</ul>
									<div v-else class="tbd mtop-20">
										<h2>No data recorded</h2>
									</div>
								</div>

							</b-col>

						</b-row>
						<b-row>
							<b-col>
								<div class="costumers" v-if="shipyard.company.customers && shipyard.company.customers.length">
									<h3>Costumers</h3>
									<b-row>
										<b-col lg="3" md="3" sm="6" v-for="(customer,i) in shipyard.company.customers" :key="i">
											<div class="imgbox">
												<img :src="customer.logo">

											</div>
											<p>{{customer.name}}</p>
										</b-col>
									</b-row>
								</div>
							</b-col>

						</b-row>

					</div>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					<div class="shipyard-facilities">

						<h3>Shipyard Facilities</h3>

							<div class="table">
							<ul class="table-head desktop-only">
								<li>Dock Name</li>
								<li>Dock Type</li>
								<li class="" style="text-align:center">Length (M)</li>
								<li style="text-align:center">Width (M)</li>
								<li style="text-align:center">Draft (M)</li>
								<li style="text-align:center">DWT</li>
								<li>&nbsp;</li>
							</ul>
							<ul class="table-head mobile-only">
								<li>D.Name</li>
								<li>D.Type</li>
								<li class="" style="text-align:center">L</li>
								<li style="text-align:center">W</li>
								<li style="text-align:center">D</li>
								<li style="text-align:center">DWT</li>
								<li style="text-align:center">&nbsp;</li>
							</ul>
							<div class="table-body" v-if="shipyard.docks.length">

								<ul class="dock-row" v-for="(dock, i) in shipyard.docks" :key="i">
									<li>{{dock.name}}</li>
									<li>{{dock.category.name}}</li>
									<li style="text-align:center">{{dock.length}}</li>
									<li style="text-align:center">{{dock.width}}</li>
									<li style="text-align:center">{{dock.draft}}</li>
									<li style="text-align:center">{{dock.lwt}}</li>
									<li>
										<button class="btn-schedules" @click="showSchedules(i)" v-b-modal.modalDockSchedules>Dock Schedules</button>
									</li>
								</ul>

							</div>
						</div>

					</div>
				</b-col>
			</b-row>

			<!-- <b-row>
				<b-col>

					<div class="related-vendor" v-if="vessels && vessels.length">
						<h3>Marine vendors arround</h3>
						<hooper :settings="hooperSettings">

							<slide v-for="(vendor, i) in vessels" :key="i">
								<div class="vendor">
									<div class="logo">
										<img :src="vendor.logo || '/images/logo3-sample.png'" alt="">
									</div>
									<div class="context">
										<span class="comp-name">{{vendor.name}}</span>
										<span class="category">{{vendor.vendorServices[0].service ? vendor.vendorServices[0].service.name : ''}}</span>
									</div>
								</div>
							</slide>

							<hooper-navigation slot="hooper-addons"></hooper-navigation>
						</hooper>
					</div>
				</b-col>
			</b-row> -->


		</b-container>

		<ModalMessageShipyard :shipyard="shipyard" @onMessageSent="onMessageSent"/>
		<ModalDockSchedules :selectedDock="selectedDock" :shipyard="shipyard" v-if="selectedDock"/>
	</div>
</template>

<script>
import ModalMessageShipyard from '~/components/modal/shipyard-message-form'
import ModalDockSchedules from '~/components/modal/dock-schedules'
import { Hooper, Slide , Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';

import Cookie from 'js-cookie'

import shipyardAPI from '@/api/shipyards'
import vendorAPI from '@/api/vendors'
export default {
	layout :'default',
	components: {
		ModalMessageShipyard,
		ModalDockSchedules,
		Hooper,
		Slide,
		HooperNavigation
	},
	head() {
		let title_page = this.shipyard ? this.shipyard.name : 'Galangan Kapal di docking.id';
		return {
			title: `${title_page} | ${this.shipyard ? this.shipyard.company.name : '' }`,
			meta: [
				{ name: 'description', hid: 'description', content: `Lihat fasilitas galangan kapal ${this.shipyard ? this.shipyard.name : ''} di kota ${this.shipyard ? this.shipyard.city.name : ''} ` },
				{ name: 'keywords', hid: 'keywords',  content: `${this.shipyard ? this.shipyard.name : '' } , Galangan Kapal ${this.shipyard ? this.shipyard.city.name : '' } ${this.shipyard ? this.shipyard.company.name : '' }`},
				// Open Graph
				{ hid: 'og:title', property: 'og:title', content: `Galangan kapal ${this.shipyard ? this.shipyard.name : ''} | Galangan di kota ${this.shipyard ? this.shipyard.city.name : ''} | DOCKING.ID` },
				{ hid: 'og:description', property: 'og:description', content: `Lihat fasilitas galangan kapal ${this.shipyard ? this.shipyard.name : ''} di kota ${this.shipyard ? this.shipyard.city.name : ''}` },
				{ hid: 'og:type', property: 'og:type', content: 'website' },
				{ hid: 'og:url', property: 'og:url', content: `https://www.docking.id/galangan/profile/${this.shipyard ? this.shipyard.slug : ''}` },
				{ hid: 'og:image', property: 'og:image', content: `${this.shipyard ? this.shipyard.logo : 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png'}` },
				// Twitter Card
				{ hid: 'twitter:card', name: 'twitter:card', content: `Galangan kapal ${this.shipyard ? this.shipyard.name : ''} | Galangan di kota ${this.shipyard ? this.shipyard.city.name : ''} | DOCKING.ID` },
				{ hid: 'twitter:site', name: 'twitter:site', content: `https://www.docking.id/galangan/profile/${this.shipyard ? this.shipyard.slug : ''}` },
				{ hid: 'twitter:title', name: 'twitter:title', content: `Galangan kapal ${this.shipyard ? this.shipyard.name : ''} | Galangan di kota ${this.shipyard ? this.shipyard.city.name : ''} | DOCKING.ID`},
				{ hid: 'twitter:description', name: 'twitter:description', content: `Lihat fasilitas galangan kapal ${this.shipyard ? this.shipyard.name : ''} di kota ${this.shipyard ? this.shipyard.city.name : ''} `},
				{ hid: 'twitter:image', name: 'twitter:image', content: `${this.shipyard ? this.shipyard.logo : 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png'}`  },
				{ hid: 'twitter:image:alt', name: 'twitter:image:alt', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png' }
			]
		}
	},
	data() {
		return {
			vessels: null,
			isFetching: true,
			slide: 0,
			sliding: null,
			hooperSettings: {
				itemsToShow: 5,
				breakpoints: {
					320: {
						centerMode: true,
						itemsToShow: 1
					},
					720: {
						itemsToShow: 3
					},
					1000: {
						itemsToShow: 4
					}
				}
			},
			url: null,
			messageSent: false,
			selectedDock: null
		}
	},
	methods: {
		onMessageSent () {
			this.messageSent = true;
		},
		onSlideStart(slide) {
			this.sliding = true
		},
		onSlideEnd(slide) {
			this.sliding = false
		},
		getLatLang(shipyard) {
			return this.$L.latLng(shipyard.lat, shipyard.long);
		},
		PopupCenter(url, title, w, h) {
			// Fixes dual-screen position                         Most browsers      Firefox
			var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
			var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

			var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

			var left = ((width / 2) - (w / 2)) + dualScreenLeft;
			var top = ((height / 2) - (h / 2)) + dualScreenTop;
			var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

			// Puts focus on the newWindow
			if (window.focus) {
				newWindow.focus();
			}
		},
		showSchedules(index) {
			this.selectedDock = this.shipyard.docks[index];
            // console.log("TCL: showSchedules -> this.schedules", this.selectedDock);
		}
	},
	computed: {
		buildService() {
			var buildService = this.$store.state.shipyard.shipyard.docks.filter(dock => dock.repair == 1);
			return buildService;
		},
		repairService() {
			var repairService = this.$store.state.shipyard.shipyard.docks.filter(dock => dock.build == 1);
			return repairService;
		},
		shipyard() {
			return this.$store.state.shipyard.shipyard;
		}
	},
	mounted() {
		if(!Cookie.get('DOCKSID')) this.$root.$emit('bv::show::modal','modalLogin');
		else this.$root.$emit('bv::hide::modal','modalLogin');
		let vendorApi = new vendorAPI(this.$axios);
		let shipyardApi = new shipyardAPI(this.$axios);
		let slug = this.$route.params.slug;

		shipyardApi.get(slug).then(shipyard => {
			this.$store.dispatch('setShipyard', shipyard.data);
			vendorApi.getAll({city_id: shipyard.cityId, page: 1, limit: 10}).then(res => {
				this.vessels = res.data;
				this.isFetching = false;
			})
		});

		this.url = 'https://docking.id/' + this.$route.params.slug;
	}

}
</script>

<style lang="scss">
@import '~/assets/scss/_mixins.scss';
@import './style.scss';
</style>
